export interface Webhook {
    id: string;
    url: string;
    event: string;
    createdAt: string;
    status: string;
}
class TransactionService {
    static async addTransaction(transaction: any): Promise<Webhook> {
        try {

            const response  = await fetch(process.env.REACT_APP_API_URL + "/transaction/add", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(transaction),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: Webhook = await response.json();
            return data;

        } catch (error) {
            console.error('Chyba pri získavaní webhookov:', error);
            throw error;
        }
    }
}

export default TransactionService;
